import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { Network } from '@root/entities/network'
import { PlatformUtil } from '@root/shared'

import { ProviderTooltipContent } from './provider-tooltip-content'
import { PROVIDER_BADGE_LABEL_MAP } from './provider-ui-util'

import type { Pair } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type ProviderBadgeProps = {
  pair: Pair.PairMinimal
} & ClassNameProps

export const ProviderShortBadge: React.FC<ProviderBadgeProps> = ({
  className,
  pair,
}) => {
  const handleExploreOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()

    const explorerLink = Network.makeExplorerContractLink(
      pair.network,
      pair.address,
    )

    PlatformUtil.openLink(explorerLink)
  }

  return (
    <Tooltip
      content={
        <ProviderTooltipContent
          provider={pair.provider}
          network={pair.network}
        />
      }
    >
      <Root className={className} onClick={handleExploreOpen}>
        {PROVIDER_BADGE_LABEL_MAP[pair.provider.id]}
      </Root>
    </Tooltip>
  )
}

const Root = styled.div`
  height: 18px;
  border-radius: 3px;
  border: 1px solid var(--background-4);
  padding-inline: 6px;

  color: var(--text-10);
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;

  white-space: nowrap;
`
